import { render, staticRenderFns } from "./ModifyComp.vue?vue&type=template&id=583bcec2&"
import script from "./ModifyComp.vue?vue&type=script&lang=js&"
export * from "./ModifyComp.vue?vue&type=script&lang=js&"
import style0 from "./ModifyComp.vue?vue&type=style&index=0&id=583bcec2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports